const state = {
    financiadorId: null,
    financiadorNom: null,
    financiadorUsaGecros: false,
};

export default state;